import React, { useState, useEffect } from "react";

import {
  CCol,
  CRow,
  CSelect,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CButton
} from "@coreui/react";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Label } from "reactstrap";

import URL from "../../config/api";
import axios from "../../config/axios";

const StatisticTrailFilters = props => {
  const token = useSelector(state => state.user.token);
  const activeRole = useSelector(state => state.general.active_roles);

  const [hierarchy, setHierarchy] = useState([]);
  const [loading, setLoading] = useState(true);

  const [groupId, setGroupId] = useState(0);
  const [regionId, setRegionId] = useState(0);
  const [schoolId, setSchoolId] = useState(0);
  const [roomId, setRoomId] = useState(0);
  const [userId, setUserId] = useState(0);

  useEffect(() => {
    axios
      .get(
        `${URL.api}activity/trail_allocation/getHierarchyAllocations${
          props.selectUser ? "?users=true" : ""
        }`,
        {
          params: { trail_id: props.id },
          headers: { authorization: `Bearer ${token}` }
        }
      )
      .then(res => {
        const group = res.data.data.length > 0 ? activeRole.group_id : 0;
        const region = res.data.data.length > 0 ? activeRole.region_id : 0;
        const school = res.data.data.length > 0 ? activeRole.school_id : 0;

        setHierarchy(res.data.data);
        setGroupId(group);
        setRegionId(region);
        setSchoolId(school);
        setLoading(false);

        props.onChange({
          groupId: group,
          regionId: region,
          schoolId: school,
          roomId: 0,
          userId: 0
        });
      });
  }, []);

  const changeGroup = async newGroupId => {
    setGroupId(newGroupId);
    setRegionId(0);
    setSchoolId(0);
    setRoomId(0);
    setUserId(0);
  };

  const changeRegion = async newRegionId => {
    setRegionId(newRegionId);
    setSchoolId(0);
    setRoomId(0);
    setUserId(0);
  };

  const changeSchool = async newSchoolId => {
    setSchoolId(newSchoolId);
    setRoomId(0);
    setUserId(0);
  };

  const changeRoom = newRoomId => {
    setRoomId(newRoomId);
    setUserId(0);
  };

  const changeUser = newUserId => {
    setUserId(newUserId);
  };

  const onClick = () => {
    if (
      props.required &&
      (!groupId ||
        !regionId ||
        !schoolId ||
        !roomId ||
        (!userId && props.selectUser))
    ) {
      toastr.warning("Atenção", "Preencha todos os campos");
      return;
    }

    props.onChange({
      groupId,
      regionId,
      schoolId,
      roomId,
      userId
    });
  };

  const groups = hierarchy;
  const regions = hierarchy.find(item => item.id === groupId)?.regions || [];
  const schools = regions.find(item => item.id === regionId)?.schools || [];
  const rooms = schools.find(item => item.id === schoolId)?.rooms || [];
  const users = rooms.find(item => item.id === roomId)?.users || [];

  if (hierarchy.length === 0 && !loading) {
    return (
      <div className="d-flex align-items-center justify-content-center text-muted mb-4">
        A avaliação ainda não foi alocada
      </div>
    );
  }

  return (
    <div className="d-flex align-items-end mb-4">
      <CRow className="flex-1">
        <CCol>
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Grupo</Label>
          </div>
          <CInputGroup>
            <CInputGroupPrepend>
              <CInputGroupText>
                <i className="fa fa-wrench"></i>
              </CInputGroupText>
            </CInputGroupPrepend>
            <CSelect
              value={groupId}
              placeholder="Grupo"
              onChange={e => changeGroup(parseInt(e.target.value))}
              disabled={!!activeRole.group_id}
            >
              {loading && <option value={0}>Carregando</option>}
              {groups.map(item => (
                <option value={item.id}>{item.name}</option>
              ))}
            </CSelect>
          </CInputGroup>
        </CCol>
        <CCol>
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Regional</Label>
          </div>
          <CInputGroup>
            <CInputGroupPrepend>
              <CInputGroupText>
                <i className="fa fa-globe"></i>
              </CInputGroupText>
            </CInputGroupPrepend>
            <CSelect
              value={regionId}
              placeholder="Regional"
              onChange={e => changeRegion(parseInt(e.target.value))}
              disabled={!!activeRole.region_id}
            >
              {loading ? (
                <option value={0}>Carregando</option>
              ) : (
                <option value={0}>
                  {props.required ? "Selecione uma regional" : "Todas"}
                </option>
              )}
              {regions.map(item => (
                <option value={item.id}>{item.name}</option>
              ))}
            </CSelect>
          </CInputGroup>
        </CCol>
        <CCol>
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Escola</Label>
          </div>
          <CInputGroup>
            <CInputGroupPrepend>
              <CInputGroupText>
                <i className="fa fa-institution"></i>
              </CInputGroupText>
            </CInputGroupPrepend>
            <CSelect
              value={schoolId}
              placeholder="Escola"
              onChange={e => changeSchool(parseInt(e.target.value))}
              disabled={!!activeRole.school_id}
            >
              {loading ? (
                <option value={0}>Carregando</option>
              ) : (
                <option value={0}>
                  {props.required ? "Selecione uma escola" : "Todas"}
                </option>
              )}
              {schools.map(item => (
                <option value={item.id}>{item.name}</option>
              ))}
            </CSelect>
          </CInputGroup>
        </CCol>
        <CCol>
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Turma</Label>
          </div>
          <CInputGroup>
            <CInputGroupPrepend>
              <CInputGroupText>
                <i className="fa fa-graduation-cap"></i>
              </CInputGroupText>
            </CInputGroupPrepend>
            <CSelect
              value={roomId}
              placeholder="Turma"
              onChange={e => changeRoom(parseInt(e.target.value))}
            >
              {loading ? (
                <option value={0}>Carregando</option>
              ) : (
                <option value={0}>
                  {props.required ? "Selecione uma turma" : "Todas"}
                </option>
              )}
              {rooms.map(item => (
                <option value={item.id}>{item.name}</option>
              ))}
            </CSelect>
          </CInputGroup>
        </CCol>
        {props.selectUser && (
          <CCol>
            <div className="w-100 text-ellipsis">
              <Label className="d-block w-100 text-ellipsis">Usuário</Label>
            </div>
            <CInputGroup>
              <CInputGroupPrepend>
                <CInputGroupText>
                  <i className="fa fa-user"></i>
                </CInputGroupText>
              </CInputGroupPrepend>
              <CSelect
                value={userId}
                placeholder="Usuário"
                onChange={e => changeUser(parseInt(e.target.value))}
              >
                {loading ? (
                  <option value={0}>Carregando</option>
                ) : (
                  <option value={0}>
                    {props.required ? "Selecione um usuário" : "Todos"}
                  </option>
                )}
                {users.map(item => (
                  <option value={item.user.id}>{item.user.name}</option>
                ))}
              </CSelect>
            </CInputGroup>
          </CCol>
        )}
      </CRow>
      <CButton
        color="primary"
        className="d-flex align-items-center ml-3"
        onClick={onClick}
      >
        <i className="fa fa-filter mr-2"></i>Filtrar
      </CButton>
    </div>
  );
};

export default StatisticTrailFilters;
